module.exports = {
	"root": "findify-layouts--autocomplete--fullscreen",
	"wrapper": "findify-layouts--autocomplete--fullscreen__wrapper",
	"type-title": "findify-layouts--autocomplete--fullscreen__type-title",
	"typeTitle": "findify-layouts--autocomplete--fullscreen__type-title",
	"suggestions-title": "findify-layouts--autocomplete--fullscreen__suggestions-title",
	"suggestionsTitle": "findify-layouts--autocomplete--fullscreen__suggestions-title",
	"trending-title": "findify-layouts--autocomplete--fullscreen__trending-title",
	"trendingTitle": "findify-layouts--autocomplete--fullscreen__trending-title",
	"not-found": "findify-layouts--autocomplete--fullscreen__not-found",
	"notFound": "findify-layouts--autocomplete--fullscreen__not-found",
	"start-typing": "findify-layouts--autocomplete--fullscreen__start-typing",
	"startTyping": "findify-layouts--autocomplete--fullscreen__start-typing",
	"tip": "findify-layouts--autocomplete--fullscreen__tip",
	"highlight": "findify-layouts--autocomplete--fullscreen__highlight",
	"container": "findify-layouts--autocomplete--fullscreen__container"
};